export enum MapPointTypes {
  standard = 'standard',
  boondock = 'boondock',
  poi = 'poi',
  user = 'user',
}
